import { configureStore } from "@reduxjs/toolkit";
import { languageSlice, languageSetterMiddleWare } from "@/redux/state/language"
// import { apiSlice } from "./state/api"
// import { homepageSlice } from "./state/homepage";
import { choicesMiddleWare, homepageSlice, initializeClientReservationMiddleWare, openModalsMiddleWare } from "@/redux/state/homepage";

export const store = configureStore({
  reducer: {
    // [apiSlice.reducerPath]: apiSlice.reducer,
    language: languageSlice.reducer,
    homepage: homepageSlice.reducer
  },
  middleware: getDefaultMiddleware =>
  getDefaultMiddleware().concat([
    languageSetterMiddleWare,
    initializeClientReservationMiddleWare,
    choicesMiddleWare,
    openModalsMiddleWare
    // apiSlice.middleware
  ])
  // middleware: [languageSetterMiddleWare, apiSlice.middleware],
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Can still subscribe to the store
// store.subscribe(() => console.log(store.getState()))
